import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Checkbox } from '../Checkbox';
import { StyledTDCheckbox, StyledTR } from './TR.styled';
export var TR = /*#__PURE__*/function (_React$Component) {
  function TR() {
    var _this;
    _classCallCheck(this, TR);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TR, [].concat(args));
    _defineProperty(_this, "trRef", /*#__PURE__*/React.createRef());
    _defineProperty(_this, "onClick", function () {
      _this.onSelect();
      if (_this.trRef.current) {
        _this.trRef.current.blur();
      }
    });
    _defineProperty(_this, "onKeyDown", function (e) {
      if (e.key === ' ') {
        e.preventDefault();
        _this.onSelect();
      }
    });
    _defineProperty(_this, "onContext", function (e) {
      var selectable = _this.props.selectable;
      if (selectable !== null && selectable !== void 0 && selectable.onContextMenu && !selectable.disabled) {
        e.preventDefault();
        selectable.onContextMenu(e);
      }
    });
    _defineProperty(_this, "onSelect", function () {
      var selectable = _this.props.selectable;
      if (selectable !== null && selectable !== void 0 && selectable.onChange && !selectable.disabled) {
        selectable.onChange(!selectable.checked);
      }
    });
    return _this;
  }
  _inherits(TR, _React$Component);
  return _createClass(TR, [{
    key: "render",
    value: function render() {
      var _this$props$selectabl, _this$props$checkBoxA;
      var applyHover = this.props.highlightOnHover === undefined ? true : this.props.highlightOnHover;
      return /*#__PURE__*/React.createElement(StyledTR, {
        selectable: !!this.props.selectable,
        selected: !!((_this$props$selectabl = this.props.selectable) !== null && _this$props$selectabl !== void 0 && _this$props$selectabl.checked),
        inactive: this.props.inactive,
        rowHeight: this.props.height,
        hover: applyHover,
        onClick: this.onClick,
        onContextMenu: this.onContext,
        tabIndex: -1,
        onKeyDown: this.onKeyDown,
        ref: this.trRef
      }, this.props.selectable && /*#__PURE__*/React.createElement(StyledTDCheckbox, null, this.props.selectable.hidden ? /*#__PURE__*/React.createElement("div", null) : /*#__PURE__*/React.createElement(Checkbox, {
        "aria-label": (_this$props$checkBoxA = this.props.checkBoxAriaLabel) !== null && _this$props$checkBoxA !== void 0 ? _this$props$checkBoxA : 'Checkbox',
        disabled: this.props.selectable.disabled,
        checked: Boolean(this.props.selectable.checked),
        tabIndex: 0
      })), this.props.children);
    }
  }]);
}(React.Component);